import useSyncedMedia from './useSyncedMedia';

const SyncedAudio = ({
  elementId,
  src,
  className,
  isTeacher,
  lessonSessionId,
  loop,
  autoPlay
}) => {
  const { mediaRef, teacherProps } = useSyncedMedia({ elementId, isTeacher, lessonSessionId });

  if (!isTeacher) {
    return (
      <audio
        ref={mediaRef}
        src={src}
        className={className}
        loop={loop}
      />
    );
  }

  return (
    <audio
      ref={mediaRef}
      src={src}
      className={className}
      controls
      controlsList="nodownload"
      loop={loop}
      autoPlay={autoPlay}
      {...teacherProps}
    />
  );
};

export default SyncedAudio;
